/**
 * action types
 */
export const DELETE_LTI_PROVIDER = 'DELETE_LTI_PROVIDER';
export const SET_LTI_PROVIDERS = 'SET_LTI_PROVIDERS';
export const SET_LTI_PROVIDER = 'SET_LTI_PROVIDER';
